module.exports = __webpack_public_path__ + "media/images/flags/64/Comoros-2c806f5105db3308dcc2e29a9a1c63fe.png";